module.exports = __webpack_public_path__ + "img/logo.10d00d2b.png";